import React from "react";
import Box from "theme/components/atoms/Layout/Box";
import compose from "recompose/compose";
import Loadable from "theme/components/helpers/Loadable";
import ErrorBoundary from "theme/components/helpers/ErrorBoundary";
import graphqlWithPreload from "web/core/apollo/graphqlWithPreload";

import BlogListQuery from "./BlogListQuery.gql";
import BlogList from "./BlogList";

const BlogListPage = (props) => {
  return (
    <ErrorBoundary>
      {({ hasError }) => {
        return hasError ? (
          <Box>We're sorry but we couldn't properly load the blog.</Box>
        ) : (
          <BlogList posts={props.posts} />
        );
      }}
    </ErrorBoundary>
  );
};

const Skeleton = () => {
  const mockPosts = [...Array(2)];
  return (
    <BlogList.Layout>
      {mockPosts.map((_, key) => (
        <div key={key} className="space-y-3">
          <div className="skeleton block h-6 w-[60%]" />
          <div className="skeleton block h-6 w-[40%]" />
          <div className="skeleton block h-32 w-full" />
        </div>
      ))}
    </BlogList.Layout>
  );
};

export default compose(
  graphqlWithPreload(BlogListQuery, {
    props: ({ data }) => ({
      loading: data.loading,
      error: !data.loading && data.error,
      posts: !data.loading && data.blog,
    }),
  }),
  Loadable((props) => !props.loading, Skeleton)
)(BlogListPage);
